import React from "react";
import classNames from "../../classNames";
import { Progress } from "../../nq-component";

export default function PreviewFormModalFooter({
  cancelText,
  confirmText,
  type = "primary",
  progress,
  onClose,
  onConfirm,
}) {
  return (
    <div className="d-flex justify-content-end gap-2 flex-shrink-0 border-top bg-light px-4 py-3 rounded-bottom-3">
      <button
        type="button"
        className="btn btn-light border fw-semibold px-3"
        onClick={onClose}
        disabled={progress}
        aria-label={cancelText}
      >
        <i className="bi bi-x-lg me-1" aria-hidden />
        {cancelText}
      </button>
      <button
        type="button"
        className={classNames(
          "btn fw-semibold px-4 d-flex align-items-center gap-2",
          "btn-" + type,
        )}
        onClick={onConfirm}
        disabled={progress}
        aria-label={progress ? "Processing" : confirmText}
      >
        {progress ? (
          <span className="d-flex align-items-center gap-2">
            <Progress aria-hidden /> Processing...
          </span>
        ) : (
          <>
            <i className="bi bi-check-lg" aria-hidden />
            {confirmText}
          </>
        )}
      </button>
    </div>
  );
}
